import { render, staticRenderFns } from "./inventorySummaryWidget.vue?vue&type=template&id=774ca815&"
import script from "./inventorySummaryWidget.vue?vue&type=script&lang=js&"
export * from "./inventorySummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports